<template>
  <a-modal v-bind="$attrs" :wrap-class-name="computedWrapClassName">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  wrapClassName?: string
}>()

const computedWrapClassName = computed(() => {
  return [props.wrapClassName || '', 'wrap-add-dialog'].filter(Boolean).join(' ')
})

defineOptions({
  name: 'AntModal',
  inheritAttrs: false
})
</script>

<style lang="less" scoped>
:global(.wrap-add-dialog .ant-modal-content) {
  padding: 0px;
}

:global(.wrap-add-dialog .ant-modal-header) {
  margin-bottom: 0px;
  padding: 24px 30px;
  border-bottom: solid 1px #A0B8E5;
}

:global(.wrap-add-dialog .ant-modal-footer) {
  margin-top: 0px;
  padding-bottom: 50px;
  text-align: center;
}

:global(.wrap-add-dialog .ant-modal-title) {
  padding-left: 5px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  color: #000;
}

:global(.wrap-add-dialog .ant-modal-footer .ant-btn-default) {
  width: 120px;
  height: 40px;
  border: 1px solid #0C418F;
  border-radius: 20px !important;
  color: #0C418F;
  font-size: 16px;
}

:global(.wrap-add-dialog .ant-modal-footer .ant-btn-primary) {
  width: 120px;
  height: 40px;
  background: #0D479C;
  border-color: #0D479C;
  border-radius: 20px !important;
  color: #fff;
  font-size: 16px;
}
</style>
